import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import home from '../assets/home-2.png';
import transaction from '../assets/note-01.png';
import product from '../assets/store.png';
import customers from '../assets/user-group.png';
import sales from '../assets/line-chart.png';
import settings from '../assets/settings.png';
import dark from '../assets/moon.png';
import agarliLogo from '../assets/agarli-logo.png';
import profilePic from '../assets/admin-avatar.png';
import toggle from '../assets/toggle-icon.png';
import arrow from '../assets/arrow-down-simple.png';
import mail from '../assets/mail.png';
import './style.css';
import DarkModeSwitch from './DarkModeSwitch';
import { useAuth } from '../contexts/AuthContext';
import { CATEGORY_LIST, CATEGORY_LABELS } from '../constants/agencyCategories';

const navActiveClass = (isActive) =>
  isActive
    ? 'agarly-nav-active'
    : 'text-agarly-gray dark:text-gray-400 hover:bg-agarly-light/60 dark:hover:bg-agarly-700';

const Sidebar = ({ isSidebarOpen, toggleSidebar, isMobileOpen }) => {
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const [isUsersOpen, setIsUsersOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const items = [
    { icon: home, label: "Dashboard", path: "/dashboard" },
    { icon: product, label: "Products", path: "/products" },
    { icon: sales, label: "Sales Report", path: "/sales" },
    { icon: customers, label: "Customers", path: "/customers" },
    { icon: settings, label: "Settings", path: "/settings" },
  ];

  return (
    <>
      <div
        className={`dark:bg-agarly-700 fixed top-0 left-0 h-screen bg-white flex flex-col justify-between shadow-agarly-md pt-3 transition-all duration-300 hidden sm:flex border-r border-agarly-surface/80 ${
          isSidebarOpen ? "w-72" : "w-20"
        }`}
      >
        <div className={`flex items-center ${isSidebarOpen ? 'flex-row justify-between' : 'flex-col'}`}>
          <img src={agarliLogo} alt="Agarly" className="w-20 h-14 object-contain transition-all duration-300" />
          <button onClick={toggleSidebar} className="p-2 m-4 hover:bg-agarly-light rounded-full transition">
            <img
              src={toggle}
              alt="Toggle"
              className={`w-6 h-6 transition-transform duration-300 ${isSidebarOpen ? "" : "rotate-180"}`}
            />
          </button>
        </div>

        <div className="overflow-y-auto text-sm font-light p-4 flex-1">
          <ul className="space-y-3 text-base">
            {isSidebarOpen && (
              <p className="text-agarly-gray text-xs uppercase mb-2 tracking-wide">General</p>
            )}

            <li className={`rounded-agarly-xl transition-all ${navActiveClass(location.pathname === "/dashboard")}`}>
              <Link to="/dashboard" className="flex items-center gap-3 p-3 rounded-agarly-lg">
                <img src={home} alt="dashboard" className="w-6 h-6" />
                {isSidebarOpen && <span>Dashboard</span>}
              </Link>
            </li>

            <li className="rounded-agarly-xl transition text-agarly-gray dark:text-gray-400">
              <div
                onClick={(e) => { e.preventDefault(); setIsProductsOpen(!isProductsOpen); }}
                className={`flex items-center justify-between w-full rounded-agarly-xl cursor-pointer transition-colors ${navActiveClass(location.pathname.startsWith("/products"))}`}
              >
                <div className="flex items-center gap-3 p-3 w-full rounded-agarly-lg">
                  <img src={product} alt="products" className="w-6 h-6" />
                  {isSidebarOpen && <span>Categories</span>}
                </div>
                {isSidebarOpen && (
                  <div className="p-3 rounded-agarly-lg">
                    <img src={arrow} alt="toggle" className={`w-5 h-5 transition-transform ${isProductsOpen ? "rotate-180" : ""}`} />
                  </div>
                )}
              </div>

              {isProductsOpen && isSidebarOpen && (
                <ul className="mt-2 space-y-2">
                  {CATEGORY_LIST.map((key) => (
                    <li key={key}>
                      <button
                        className={`block w-full text-left px-2 py-1 pl-8 rounded-agarly-md transition-colors ${
                          location.search.includes(`selected=${key}`)
                            ? 'bg-agarly-light text-agarly-dark font-semibold'
                            : 'hover:bg-agarly-light/50 dark:hover:bg-agarly-700'
                        }`}
                        onClick={() => navigate(`/products?selected=${key}`)}
                      >
                        {CATEGORY_LABELS[key]}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            <li className="rounded-agarly-xl transition text-agarly-gray dark:text-gray-400">
              <div
                onClick={(e) => { e.preventDefault(); setIsUsersOpen(!isUsersOpen); }}
                className={`flex items-center justify-between w-full rounded-agarly-xl cursor-pointer transition-colors ${navActiveClass(location.pathname.startsWith("/Users"))}`}
              >
                <div className="flex items-center gap-3 p-3 w-full rounded-agarly-lg">
                  <img src={customers} alt="users" className="w-6 h-6" />
                  {isSidebarOpen && <span>Users</span>}
                </div>
                {isSidebarOpen && (
                  <div className="p-3 rounded-agarly-lg">
                    <img src={arrow} alt="toggle" className={`w-5 h-5 transition-transform ${isUsersOpen ? "rotate-180" : ""}`} />
                  </div>
                )}
              </div>

              {isUsersOpen && isSidebarOpen && (
                <ul className="mt-2 space-y-2">
                  {[
                    { name: "Vendors", key: "vendors" },
                    { name: "Customers", key: "customers" },
                  ].map((item) => (
                    <li key={item.key}>
                      <button
                        className={`block w-full text-left px-2 py-1 pl-8 rounded-agarly-md transition-colors ${
                          location.search.includes(`selected=${item.key}`)
                            ? 'bg-agarly-light text-agarly-dark font-semibold'
                            : 'hover:bg-agarly-light/50 dark:hover:bg-agarly-700'
                        }`}
                        onClick={() => navigate(`/Users?selected=${item.key}`)}
                      >
                        {item.name}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            {[
              { path: "/transactions", icon: transaction, label: "Orders" },
              { path: "/sales", icon: sales, label: "Sales Report" },
            ].map((item) => (
              <li key={item.path} className={`rounded-agarly-xl transition-all ${navActiveClass(location.pathname.startsWith(item.path))}`}>
                <Link to={item.path} className="flex items-center gap-3 p-3 rounded-agarly-lg">
                  <img src={item.icon} alt={item.label} className="w-6 h-6" />
                  {isSidebarOpen && <span>{item.label}</span>}
                </Link>
              </li>
            ))}

            {isSidebarOpen && (
              <p className="text-agarly-gray text-xs uppercase mb-2 tracking-wide">Tools</p>
            )}

            {[
              { path: "/settings", icon: settings, label: "Account & Settings" },
              { path: "/chat", icon: mail, label: "Chat" },
            ].map((item) => (
              <li key={item.path} className={`rounded-agarly-xl transition-all ${navActiveClass(location.pathname === item.path)}`}>
                <Link to={item.path} className="flex items-center gap-3 p-3 rounded-agarly-lg">
                  <img src={item.icon} alt={item.label} className="w-6 h-6" />
                  {isSidebarOpen && <span>{item.label}</span>}
                </Link>
              </li>
            ))}

            <li>
              <div className="flex justify-between dark:text-gray-400 items-center gap-3 p-3 rounded-agarly-lg">
                <div className="flex items-center gap-3">
                  <img src={dark} alt="darkmode" className="w-6 h-6" />
                  {isSidebarOpen && <span>Dark Mode</span>}
                </div>
                {isSidebarOpen && <DarkModeSwitch />}
              </div>
            </li>
          </ul>
        </div>

        <Link to="/settings" className="flex items-center gap-2 border border-agarly-surface dark:border-agarly-700 rounded-agarly-xl p-2 m-2">
          <img
            src={user?.profileImage || profilePic}
            alt="User"
            className="w-10 h-10 rounded-agarly-lg object-cover"
          />
          {isSidebarOpen && (
            <div>
              <p className="text-sm font-medium text-agarly-dark dark:text-gray-300">{user?.name}</p>
              <p className="text-xs text-agarly-gray dark:text-gray-400">{user?.role}</p>
            </div>
          )}
        </Link>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out bg-white shadow-md w-full px-4 ${
          isMobileOpen ? "max-h-96 py-4 mt-16" : "max-h-0"
        }`}
      >
        <ul className="space-y-4">
          {items.map((item) => (
            <li key={item.path}>
              <Link to={item.path} className="flex items-center gap-3 text-agarly-dark hover:text-agarly-secondary">
                <img src={item.icon} alt={item.label} className="w-6 h-6" />
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
